import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import PluviometroList from './pluviometroList';
import * as pluviometroActions from './pluviometroActions';
import SelectConfGrupoFisicoPluviometro from '../common/selectdb/selectConfGrupoFisicoPluviometro';
import SelectConfControladorPluviometro from '../common/selectdb/selectConfControladorPluviometro';

class PluviometroTempoReal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshKey: 0,
    };
    this.changeControlador = this.changeControlador.bind(this);
  }

  changeControlador() {
    // Qualquer mudança em grupo/controlador força recarregar os dados do List
    this.setState(prev => ({ refreshKey: prev.refreshKey + 1 }));
  }

  render() {
    return (
      <div>
        <div className="contentHeaderFilter pluviometro-tempo-real-filter">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <SelectConfGrupoFisicoPluviometro onChange={this.changeControlador} />
          </div>
          <SelectConfControladorPluviometro anel={false} onChange={this.changeControlador} />
        </div>
        <Content>
          <PluviometroList activeTab="tempo-real" refreshKey={this.state.refreshKey} />
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...pluviometroActions,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PluviometroTempoReal);
